import React from "react";
import { useNavigate } from "react-router-dom";
// import NewsHeroSection from "../components/News/NewsHeroSection";
// import NewsHighlight from "../components/News/newsHighlisght";
// import LatestNews from "../components/News/LatestNews";
// import TrendingNews from "./components/TrendingNews";
// import LatestArticles from "./components/LatestArticles";
// import VideoNews from "./components/VideoNews";
// import PodcastSection from "./components/PodcastSection";
// import BasketballNews from "./components/BasketballNews";
import newsData from "../NewsData/newsData";
import NewsCard from "../components/NewsCard";
import HeroSection from "../components/HeroSection";
import NewsletterSubscription from "../components/NewsletterSubscription";

import newsHeroImage from '../assets/WhatsApp Image 2025-08-07 at 18.30.25_cc7fb72e.jpg'; // Replace with your actual image path

const NewsPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <HeroSection
        image={newsHeroImage}
        title="News & Press Releases"
        description="Stay updated with our latest news and press releases. Explore our insights, achievements, and contributions to the industry."
      />
      
      <div style={{display:'flex',justifyContent:'center',padding:'20px 0'}} >
        <h2 style={{color:'#1a3055',fontSize:'2.5rem',margin:0,fontWeight:700,borderBottom:'3px solid #1a3055'}}>All News</h2>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          margin: '20px 0',
          flexWrap: 'wrap',
        }}
      >
        {newsData &&
          newsData.map((news, index) => (
            <div key={index} style={{ flex: "1 1 300px", maxWidth: "350px" }}>
              <NewsCard
                image={news?.image}
                title={news?.title}
                description={news?.description[0].dsc_text}
                onClick={() => navigate(`/news-details/${news?._id}`)}
              />
            </div>
          ))}
      </div>

      <div style={{padding:'20px'}}>
        <NewsletterSubscription />
      </div>
      {/* <NewsHeroSection data={newsData} />
      <div style={{marginTop:'20px',padding:'30px'}}>
        <h2>Recent News</h2>
        <NewsHighlight data={newsData?.slice(1,3)} />
      </div> */}

      {/* <div style={{marginTop:'50px'}}>
        <LatestNews />
      </div> */}
      {/* <TrendingNews />
      <LatestArticles />
      <VideoNews />
      <PodcastSection />
      <BasketballNews /> */}
    </div>
  );
};

export default NewsPage;
